// Channel keys the backend supports (CHANNEL_HANDLERS in reminder_setup/channel/controller.js).
export const CHANNEL_LABEL = {
  EMAIL: "Email",
  IN_APP: "In-app notification",
  SMS: "SMS",
  WHATSAPP: "WhatsApp",
};
